<template>
	<div
		v-editable="blok"
		:ref="(el) => (rootDiv = el)"
		class="grid-cols-2-media fluid grid h-full grid-rows-1 bg-white"
	>
		<form
			class="flex w-full flex-col justify-center"
			:class="{ 'px-16 py-8': !blok?.noPadding }"
			@submit.stop.prevent="$emit('submit')"
		>
			<template
				v-for="b in props.blok?.content"
				:key="b._uid"
			>
				<component
					v-if="rootDiv"
					:blok="b"
					:parentSwiper="parentSwiper"
					:parentDivRef="rootDiv"
					:slideId="blok?._uid"
					:is="b.component"
					:isLargeSize="false"
					:active="active"
				/>
			</template>
			<button
				type="submit"
				class="hidden"
			></button>
		</form>
		<SbMedia
			:active="active"
			:blok="media"
		/>
	</div>
</template>

<script setup lang="ts">
import SbMedia from '@/components/blocks/SbMedia.vue'
import type { TwoColumnContentAssetStoryblok } from '@/sbTypes'
import { Swiper } from 'swiper'
import { type PropType, ref, computed } from 'vue'

const rootDiv = ref()
const props = defineProps({
	blok: Object as PropType<TwoColumnContentAssetStoryblok>,
	parentSwiper: Swiper,
	active: Boolean,
})

const media = computed(() => props.blok?.media[0])
</script>
